import { config } from '../config';
import { parseStatus, type OperatorStatus } from '../lib/operatorStatus';

type ApiFetch = (url: string, init?: RequestInit) => Promise<Response>;

/**
 * Your own status in a workspace (gateway `GET|PUT /api/operator/status`). Only "working" people who are
 * connected can be given conversations by an admin; your status never stops you taking one yourself.
 */
export const operatorStatusService = {
  async get(apiFetch: ApiFetch, tenantId: string): Promise<OperatorStatus> {
    const res = await apiFetch(`${config.apiServer}/api/operator/status?tenantId=${encodeURIComponent(tenantId)}`);
    if (!res.ok) throw new Error(`operator status failed: ${res.status}`);
    return parseStatus(((await res.json()) as { status?: unknown }).status);
  },

  async set(apiFetch: ApiFetch, tenantId: string, status: OperatorStatus): Promise<OperatorStatus> {
    const res = await apiFetch(`${config.apiServer}/api/operator/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tenantId, status }),
    });
    if (!res.ok) throw new Error(`operator status save failed: ${res.status}`);
    return parseStatus(((await res.json()) as { status?: unknown }).status);
  },
};
